import { apiCallCenter } from '@/plugins/axios'
import { hostname } from '@/utils/hostname'

export default {
  getValoresTotaisResumidoFila(data) {
    return apiCallCenter().post('/relatorios/filas/resumido/total?_method=GET', data)
  },

  getValoresDiasCorridosResumidoFila(data) {
    return apiCallCenter().post('/relatorios/filas/resumido/dia-corrido?_method=GET', data)
  },

  getValoresMediaDiasResumidoFila(data) {
    return apiCallCenter().post('/relatorios/filas/resumido/media-dia?_method=GET', data)
  },

  getValoresHoraResumidoFila(data) {
    return apiCallCenter().post('/relatorios/filas/resumido/hora?_method=GET', data)
  },

  getValoresMediaHoraResumidoFila(data) {
    return apiCallCenter().post('/relatorios/filas/resumido/media-hora?_method=GET', data)
  },

  exportExcel(params) {
    let query = new URLSearchParams(params.dateTimeRange).toString();

    if(params.filas.length == 0){
      query = `${query}&filas[]=${params.filas}`
    }else{
      params.filas.forEach(fila => {
        query = `${query}&filas[]=${fila}`
      })
    }
    if(params.maiorQue != 0){
      query = `${query}&maiorQue=${params.maiorQue}`
    }else{
      query = `${query}&maiorQue=0`
    }
    if(params.menorQue != 0){
      query = `${query}&menorQue=${params.menorQue}`
    }else{
      query = `${query}&menorQue=0`
    }
    if(params.centrosDeCusto.length == 0){
      query = `${query}&centrosDeCusto[]=${params.centrosDeCusto}`
    }else{
      params.centrosDeCusto.forEach(centrosDeCusto => {
        query = `${query}&centrosDeCusto[]=${centrosDeCusto}`
      })
    }

    const token = window.localStorage.getItem('pcm_access_token')
    query = `${query}&token=${token}`
    return `https://${hostname()}/backend/callcenter/relatorios/filas/resumido/export?${query}`
  },
}
